import { type CSSProperties, memo } from 'react';

import { classesBuilder } from '@common/helpers';

import { E_ARROW_TEXT, type TButtonArrowProps } from './types';

import style from './styles.module.scss';

const ArrowButton = (props: TButtonArrowProps) => {
  const { direction = 'left', className, color, disabled = false, scale = 1, onClick } = props;

  return (
    <button
      data-testid="button-arrow"
      className={classesBuilder(className, style.arrow, style[direction], { [style.disabled]: disabled })}
      style={
        {
          '--scale': scale.toString(),
          '--color': color,
        } as CSSProperties
      }
      onClick={onClick}
      disabled={disabled}
    >
      {E_ARROW_TEXT[direction]}
    </button>
  );
};

export default memo(ArrowButton);
